import { getAuth, signInWithCustomToken } from "firebase/auth"
import { useEffect, useMemo } from "react"
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Pages } from 'routes';
import { useAppSelector } from 'store/hooks';
import { selectUserProfile } from 'store/user/selectors';
import { Mixpanel } from 'utils/mixpanel';
import mixpanel from 'mixpanel-browser';

const CustomAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userProfile = useAppSelector(selectUserProfile);

  const customToken = useMemo(() => {
    return searchParams.get("customToken");
  }, [searchParams]);

  const redirectTo = useMemo(() => {
    return searchParams.get("redirectTo");
  }, [searchParams]);

  const trackExternalVendor = () => {
    if (userProfile?.externalVendor) {
      mixpanel.register_once({
        ExternalVendor: userProfile?.externalVendor,
      });
      Mixpanel.setUserProperties({
        ExternalVendor: userProfile?.externalVendor,
      });
    }
  };

  useEffect(() => {
    if (customToken === null || customToken === "") return;

    const auth = getAuth();
    signInWithCustomToken(auth, customToken)
      .then(() => {
        trackExternalVendor();
        navigate(redirectTo || Pages.VENDOR_DASHBOARD, { replace: true });
      })
      .catch((err) => console.log("AuthErr", err));
  }, [customToken, redirectTo]);

  useEffect(() => {
    trackExternalVendor();
  }, [userProfile]);

  if (customToken === null || customToken === "") {
    return <div><h1>Please include the user's custom token in the query param "customToken"</h1></div>
  }

  return <div></div>
}

export default CustomAuth;
